import BaseEvent from './BaseEvent';
class StandardEvents {
    identify() {
        return new BaseEvent('identify');
    }
}
export default StandardEvents;
//# sourceMappingURL=StandardEvents.js.map